.family-goals-step{display:flex;flex-direction:column;gap:24px;max-width:480px}
/*# sourceMappingURL=family-goals-step.component-RS47FKPI.css.map */
